import Vue from 'vue'
import Router from 'vue-router'
import { store } from '../vuex'

import Home     from "@/components/HomeComponent"
import Login    from "@/components/LoginComponent"
//import Register from "@/components/RegisterComponent"
import Avatar   from "@/components/AvatarComponent"
import Ranking  from "@/components/RankingComponent"
import Game     from "@/components/GameComponent"
//import Exit     from "@/components/ExitComponent"
import Item     from "@/components/ItemComponent"
import InfoDesktop from "@/components/InfoDesktopComponent"
import InfoMobile from "@/components/InfoMobileComponent"
import Terms from "@/components/TermsComponent"

Vue.use(Router)

const routes = 
[
    {
        name: 'home',
        path: '/',
        component: Home,
        meta: { title: 'Vamos começar? - Agrinhos', requiresLogin: false }
    },
    {
        name: 'entrar',
        path: '/entrar',
        component: Login,
        meta: { title: 'Acesso - Agrinhos', requiresLogin: false }
    },
    /*{
        name: 'cadastro',
        path: '/cadastro',
        component: Register,
        meta: { title: 'Cadastro - Agrinhos', requiresLogin: false }
    },*/
    {
        name: 'avatar',
        path: '/avatar',
        component: Avatar,
        meta: { title: 'Avatar - Agrinhos', requiresLogin: true }
    },
    {
        name: 'jogo',
        path: '/jogo',
        component: Game,
        meta: { title: 'Jogo - Agrinhos', requiresLogin: true }
    },
    {
        name: 'ranking',
        path: '/ranking',
        component: Ranking,
        meta: { title: 'Ranking - Agrinhos', requiresLogin: true }
    },
    /*{
        name: 'sair',
        path: '/sair',
        component: Exit,
        meta: { title: 'Sair do jogo - Agrinhos', requiresLogin: true }
    },*/
    {
        name: 'coleta',
        path: '/coleta',
        component: Item,
        meta: { title: 'Coleta - Agrinhos', requiresLogin: true }
    },
    {
        name: 'instrucoes-desktop',
        path: '/instrucoes-desktop',
        component: InfoDesktop,
        meta: { title: 'Instruções para desktop - Agrinhos', requiresLogin: true }
    },
    {
        name: 'instrucoes-mobile',
        path: '/instrucoes-mobile',
        component: InfoMobile,
        meta: { title: 'Intruções para dispositivo móvel - Agrinhos', requiresLogin: true }
    },
    {
        name: 'termos-de-privacidade',
        path: '/termos-de-privacidade',
        component: Terms,
        meta: { title: 'Termos de privacidade - Agrinhos', requiresLogin: false }
    },
]

const router = new Router({ routes })

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    if (store.state.started) {
        if ((to.matched.some(record => record.meta.requiresLogin)) && (!store.state.logged))
            next({ name: 'entrar' })
        else if (((to.name === 'home') || (to.name === 'entrar') || (to.name === 'cadastro')) && (store.state.logged)) {
            next({ name: 'avatar' })
        }
        else
            next()
    }
    else
        next()
})

/*router.afterEach((to, from) => {
    to, from;
    if (to.name !== 'jogo') {
        //
    }
})*/

export default router